import {EChannelType, EContentType} from 'src/constants';
import {EWhatsAppCategory} from 'src/containers/MessageMatchers/WhatsAppForm/definitions';
import {
  EType,
  TMessageMatcherButton,
  TWhatsAppContent,
} from 'src/containers/MessageMatchers/definitions';

import {selectFilters, setFiltersAction} from './slice';

type TMessageMatcherPresetForm = {
  name: string;
  subjectId: number | null;
  subjectIds: number[];
  buttons?: TMessageMatcherButton[];
};

type TMessageMatcherPreset = {
  id: number;
  type?: EType;
  channelType: EChannelType;
  industry: string;
  topic: string;
  name: string;
  contentType?: EContentType;
  category: EWhatsAppCategory;
  content: TWhatsAppContent;
  contentExample: TWhatsAppContent;
  language?: string;
};

type TFilters = {
  filter?: string;
  industries: string[];
  topics: string[];
};

const LIST_CONFIG = {
  filtersConfig: {
    defaultFilters: {
      filter: '',
      topics: [],
      industries: [],
    },
    action: setFiltersAction,
    selector: selectFilters,
  },
};

const COLUMNS_COUNT = 3;

export type {TMessageMatcherPreset, TFilters, TMessageMatcherPresetForm};
export {LIST_CONFIG, COLUMNS_COUNT};
